import DOMPurify from 'dompurify';

// リッチテキストエディタ由来ではない汎用コンテンツ向け。オプションなしの DOMPurify デフォルト許可リストのみを使う。
export function sanitizeHtml(content: string): string {
  return DOMPurify.sanitize(content);
}
